/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import { standards } from '@g17eco/core';
import { ScopeGroups } from '@g17eco/types/surveyCommon';
import { ViewValues } from '../../types/surveyOverview';
import { DelegationScopeOptions, standardsAndFrameworkTypes, StandardsFrameworksTypes, VirtualScopeType, virtualTypes } from '../../types/surveyVirtualScope';
import { DelegationScope } from '../../types/surveyDelegation';

export const isVirtualType = (type: string): type is VirtualScopeType => {
  return virtualTypes.includes(type as VirtualScopeType);
}

export const isStandardFrameworkType = (type: ViewValues): type is StandardsFrameworksTypes => {
  return standardsAndFrameworkTypes.includes(type as StandardsFrameworksTypes);
}

const isVirtualScope = (scopeType: DelegationScopeOptions): scopeType is VirtualScopeType => {
  return virtualTypes.includes(scopeType as VirtualScopeType);
};

export const getDelegationScope = (delegationScope: DelegationScopeOptions, firstValue: string): keyof DelegationScope => {
  if (isVirtualScope(delegationScope)) {
    return standards[firstValue] ? ScopeGroups.Standards : ScopeGroups.Frameworks
  }
  return delegationScope
};
